/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Active from './Active/index'
import InActive from './InActive/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/MessageIndicatorIcon/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Active'
let inboxUnreadCountValueData = fromData.useDataFormat({ viewPath,
context: 'inbox_unread_count',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: inboxUnreadCountValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Active'}>
<Active
  viewPath={`${viewPath}/Active`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InActive'}>
<InActive
  viewPath={`${viewPath}/InActive`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}